import React from 'react';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';

import { AppTable, AppTableColumn } from '../../table/appTable';
import Button from '../../buttons/button';
import { createLink } from '../utils/link-builder';

import {
  EditParticipantFormDataProps,
  ParticipantActionButtonsProps,
  ParticipantsTableProps,
} from './participant.types';

const ActionButtons = ({ original, onDelete, onEdit }: ParticipantActionButtonsProps) => {
  const { id, orderIndex, firstName, lastName, firstSubtitle, secondSubtitle, message } = original;
  const participantBasicValues: EditParticipantFormDataProps = {
    id,
    orderIndex,
    firstName,
    lastName,
    firstSubtitle,
    secondSubtitle,
    message,
  };

  return (
    <>
      <Button
        text="Delete Participant"
        icon={faTrash}
        slimButton
        onClick={e => {
          e.stopPropagation();
          onDelete(original.id);
        }}
      />
      <Button
        text="Edit Participant"
        icon={faEdit}
        slimButton
        onClick={e => {
          e.stopPropagation();
          onEdit(participantBasicValues);
        }}
      />
    </>
  );
};

export const ParticipantsTable = ({ participants, isLoading, onClickDelete, onClickEdit }: ParticipantsTableProps) => {
  const columns: AppTableColumn[] = [
    {
      Header: '#',
      id: 'orderIndex',
      accessor: 'orderIndex',
      width: 50,
    },
    {
      Header: 'First Name',
      id: 'firstName',
      accessor: 'firstName',
      width: 150,
    },
    {
      Header: 'Last Name',
      id: 'lastName',
      accessor: 'lastName',
      width: 150,
    },
    {
      Header: 'Subtitle 1',
      id: 'firstSubtitle',
      accessor: 'firstSubtitle',
      width: 300,
    },
    {
      Header: 'Subtitle 2',
      id: 'secondSubtitle',
      accessor: 'secondSubtitle',
      width: 300,
    },
    {
      Header: 'Image',
      id: 'image',
      accessor: 'imageUrl',
      width: 300,
      Cell: ({ row }) => createLink(row, 'image', 'View Image'),
    },
    {
      Header: 'Audio',
      id: 'audio',
      accessor: 'audioUrl',
      width: 300,
      Cell: ({ row }) => createLink(row, 'audio', 'Listen to Audio'),
    },
    {
      Header: 'Message',
      id: 'message',
      accessor: 'message',
      width: 300,
    },
    {
      Header: 'Live Video',
      id: 'liveVideo',
      accessor: 'liveVideoUrl',
      width: 300,
      Cell: ({ row }) => createLink(row, 'liveVideo', 'Watch Live Video'),
    },
    {
      Header: 'Message Video',
      id: 'messageVideo',
      accessor: 'messageVideoUrl',
      width: 300,
      Cell: ({ row }) => createLink(row, 'messageVideo', 'Watch Message Video'),
    },
    {
      Header: 'Slide',
      id: 'slide',
      accessor: 'slideUrl',
      width: 300,
      Cell: ({ row }) => createLink(row, 'slide', 'View Slide'),
    },
    {
      Header: 'Actions',
      id: 'actions',
      accessor: 'actions',
      width: 300,
      Cell: ({ original }) => <ActionButtons original={original} onDelete={onClickDelete} onEdit={onClickEdit} />,
    },
  ];

  return (
    <AppTable
      columns={columns}
      tableName="participant-management"
      loading={isLoading}
      data={participants}
      defaultSorted={[{ id: 'index', desc: false }]}
    />
  );
};
